import { OvlAddComponent } from "../../../../../../_ovlclient/src/global/globals"
import { CompBPFilter } from "./bpfilter"

export const GENBPFilter_Init = () => {
  OvlAddComponent("comp-genbpfilter", CompBPFilter)
}
